/* DishCleany — interacciones propias (sin librerías). */
(function () {
  if (window.__dcInit) return;
  window.__dcInit = true;

  var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ---------- Revelado al hacer scroll ---------- */
  var observer = null;
  function initReveal(root) {
    var els = (root || document).querySelectorAll('.dc-reveal:not(.dc-visible)');
    if (!els.length) return;
    if (reduceMotion || !('IntersectionObserver' in window)) {
      els.forEach(function (el) { el.classList.add('dc-visible'); });
      return;
    }
    if (!observer) {
      observer = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          if (e.isIntersecting) { e.target.classList.add('dc-visible'); observer.unobserve(e.target); }
        });
      }, { rootMargin: '0px 0px -8% 0px', threshold: 0.08 });
    }
    els.forEach(function (el) { observer.observe(el); });
    if (!window.__dcRevealScroll) {
      window.__dcRevealScroll = true;
      var pend = false;
      window.addEventListener('scroll', function () {
        if (pend) return; pend = true;
        requestAnimationFrame(function () {
          pend = false;
          document.querySelectorAll('.dc-reveal:not(.dc-visible)').forEach(function (el) {
            if (el.getBoundingClientRect().top < window.innerHeight * 0.95) el.classList.add('dc-visible');
          });
        });
      }, { passive: true });
    }
  }

  /* ---------- Burbujas del hero ---------- */
  function initBurbujas(root) {
    if (reduceMotion) return;
    (root || document).querySelectorAll('[data-dc-burbujas]').forEach(function (cont) {
      if (cont.childElementCount) return;
      var n = parseInt(cont.getAttribute('data-dc-burbujas'), 10) || 0;
      for (var i = 0; i < n; i++) {
        var b = document.createElement('i');
        var size = 10 + Math.random() * 34;
        b.style.width = b.style.height = size + 'px';
        b.style.left = Math.random() * 100 + '%';
        b.style.animationDuration = 9 + Math.random() * 12 + 's';
        b.style.animationDelay = -Math.random() * 20 + 's';
        cont.appendChild(b);
      }
    });
  }

  /* ---------- Parallax suave ---------- */
  function initParallax() {
    if (reduceMotion) return;
    var items = [];
    document.querySelectorAll('[data-dc-parallax]').forEach(function (el) {
      items.push({ el: el, k: (parseFloat(el.getAttribute('data-dc-parallax')) || 0) / 100 });
    });
    if (!items.length) return;
    var ticking = false;
    function update() {
      items.forEach(function (it) {
        var r = it.el.parentElement.getBoundingClientRect();
        var off = (r.top + r.height / 2 - window.innerHeight / 2) * it.k;
        it.el.style.transform = 'translate3d(0,' + off.toFixed(1) + 'px,0) scale(' + (1 + it.k * 0.6) + ')';
      });
      ticking = false;
    }
    window.addEventListener('scroll', function () {
      if (!ticking) { ticking = true; requestAnimationFrame(update); }
    }, { passive: true });
    update();
  }

  /* ---------- Formato de precio ---------- */
  function formatoDinero(cents, moneda) {
    try {
      return new Intl.NumberFormat(document.documentElement.lang || 'es-ES', { style: 'currency', currency: moneda || 'EUR' }).format(cents / 100);
    } catch (e) {
      return (cents / 100).toFixed(2).replace('.', ',') + ' €';
    }
  }

  function formatoTienda(cents, formato, moneda) {
    if (!formato) return formatoDinero(cents, moneda);
    function miles(n, dec, sepMil, sepDec) {
      var partes = (n / 100).toFixed(dec).split('.');
      partes[0] = partes[0].replace(/\B(?=(\d{3})+(?!\d))/g, sepMil);
      return partes.join(sepDec);
    }
    return formato.replace(/\{\{\s*(\w+)\s*\}\}/, function (_, clave) {
      switch (clave) {
        case 'amount': return miles(cents, 2, ',', '.');
        case 'amount_no_decimals': return miles(cents, 0, ',', '.');
        case 'amount_with_comma_separator': return miles(cents, 2, '.', ',');
        case 'amount_no_decimals_with_comma_separator': return miles(cents, 0, '.', ',');
        case 'amount_with_apostrophe_separator': return miles(cents, 2, "'", '.');
        default: return miles(cents, 2, '.', ',');
      }
    });
  }

  /* ---------- Galería ---------- */
  function initGaleria(gal) {
    if (gal.__dc) return; gal.__dc = true;
    var principal = gal.querySelector('[data-dc-principal]');
    var minis = Array.prototype.slice.call(gal.querySelectorAll('[data-dc-mini]'));
    var contador = gal.querySelector('[data-dc-contador]');
    if (!principal || !minis.length) return;
    var actual = Math.max(0, minis.findIndex(function (m) { return m.getAttribute('aria-current') === 'true'; }));

    function ir(i) {
      if (i < 0) i = minis.length - 1;
      if (i >= minis.length) i = 0;
      actual = i;
      var m = minis[i];
      principal.style.opacity = 0;
      setTimeout(function () {
        principal.src = m.getAttribute('data-src');
        principal.srcset = m.getAttribute('data-srcset') || '';
        principal.alt = m.getAttribute('data-alt') || '';
        principal.style.opacity = 1;
      }, 150);
      minis.forEach(function (x, j) { x.setAttribute('aria-current', j === i ? 'true' : 'false'); });
      m.scrollIntoView({ block: 'nearest', inline: 'center', behavior: reduceMotion ? 'auto' : 'smooth' });
      if (contador) contador.textContent = (i + 1) + ' / ' + minis.length;
    }
    minis.forEach(function (m, i) { m.addEventListener('click', function () { ir(i); }); });
    var prev = gal.querySelector('[data-dc-prev]'), next = gal.querySelector('[data-dc-next]');
    if (prev) prev.addEventListener('click', function () { ir(actual - 1); });
    if (next) next.addEventListener('click', function () { ir(actual + 1); });

    var x0 = null;
    principal.parentElement.addEventListener('touchstart', function (e) { x0 = e.touches[0].clientX; }, { passive: true });
    principal.parentElement.addEventListener('touchend', function (e) {
      if (x0 === null) return;
      var dx = e.changedTouches[0].clientX - x0;
      if (Math.abs(dx) > 40) ir(actual + (dx < 0 ? 1 : -1));
      x0 = null;
    }, { passive: true });

    gal.__irMedia = function (mediaId) {
      var i = minis.findIndex(function (m) { return m.getAttribute('data-media-id') === String(mediaId); });
      if (i > -1 && i !== actual) ir(i);
    };
  }

  /* ---------- Formulario de compra (variantes + añadir al carrito) ---------- */
  function initCompra(box) {
    if (box.__dc) return; box.__dc = true;
    var dataEl = box.querySelector('[data-dc-variantes]');
    var variantes = dataEl ? JSON.parse(dataEl.textContent) : [];
    var preciosEl = box.querySelector("[data-dc-precios]");
    var precios = {};
    try { precios = preciosEl ? JSON.parse(preciosEl.textContent) : {}; } catch (e) {}
    function precioTexto(v, campo) { var p = precios[v.id]; return p && p[campo] ? p[campo] : formatoDinero(campo === "p" ? v.price : v.compare_at_price, moneda); }
    var form = box.querySelector('form[action*="/cart/add"]');
    if (!form) return;
    var idInput = form.querySelector('input[name="id"]');
    var boton = form.querySelector('[data-dc-boton]');
    var botonTexto = boton ? boton.querySelector('[data-dc-boton-texto]') : null;
    var moneda = box.getAttribute('data-moneda');
    var textos = { comprar: box.getAttribute('data-txt-comprar'), agotado: box.getAttribute('data-txt-agotado'), anadiendo: box.getAttribute('data-txt-anadiendo') };
    var error = box.querySelector('[data-dc-error]');
    var qty = form.querySelector('input[name="quantity"]');
    var seccion = box.closest('.shopify-section');
    var formato = box.getAttribute('data-formato');
    var packRadios = box.querySelectorAll('[data-dc-pack]');
    var colorUds = box.querySelectorAll('[data-dc-color-ud]');
    var cantidadBox = box.querySelector('[data-dc-cantidad]');
    var varActual = null;
    function packSel() { var r = box.querySelector('[data-dc-pack]:checked'); return r ? { n: parseInt(r.value, 10) || 1, desc: parseInt(r.getAttribute('data-desc'), 10) || 0 } : null; }
    function esPack() { var p = packSel(); return !!p && p.n > 1; }
    function variantesPack(n) {
      var lista = [varActual];
      for (var u = 2; u <= n; u++) {
        var fs = box.querySelector('[data-dc-color-ud="' + u + '"]');
        var r = fs ? fs.querySelector('input:checked') : null;
        var id = r ? parseInt(r.value, 10) : null;
        lista.push(variantes.find(function (x) { return x.id === id; }) || varActual);
      }
      return lista;
    }
    function pintarPack() {
      var v = varActual; if (!v) return;
      packRadios.forEach(function (r) {
        var n = parseInt(r.value, 10) || 1, desc = parseInt(r.getAttribute('data-desc'), 10) || 0;
        var bruto = variantesPack(n).reduce(function (t, x) { return t + x.price; }, 0);
        var p = box.querySelector('[data-dc-precio-' + n + ']'), a = box.querySelector('[data-dc-antes-' + n + ']'), ud = box.querySelector('[data-dc-ud-' + n + ']');
        if (p) p.textContent = formatoTienda(bruto - desc, formato, moneda);
        if (a) a.textContent = formatoTienda(bruto, formato, moneda);
        if (ud) ud.textContent = ud.getAttribute('data-plantilla').replace('[precio]', formatoTienda(Math.round((bruto - desc) / n), formato, moneda));
      });
      var sel = packSel() || { n: 1, desc: 0 };
      var lista = variantesPack(sel.n);
      var total = lista.reduce(function (t, x) { return t + x.price; }, 0) - sel.desc;
      colorUds.forEach(function (fs) {
        var u = parseInt(fs.getAttribute('data-dc-color-ud'), 10);
        fs.hidden = sel.n < u;
        var el = fs.querySelector('[data-dc-color-elegido]'); if (el && lista[u - 1]) el.textContent = lista[u - 1].title;
      });
      if (cantidadBox && packRadios.length) cantidadBox.hidden = true;
      box.classList.toggle('dc-compra--pack', sel.n > 1);
      box.setAttribute('data-pack-n', sel.n);
      document.querySelectorAll('[data-dc-precio="' + box.id + '"]').forEach(function (el) {
        el.textContent = sel.n > 1 ? formatoTienda(total, formato, moneda) : precioTexto(v, 'p');
      });
    }
    packRadios.forEach(function (r) { r.addEventListener('change', pintarPack); });
    colorUds.forEach(function (fs) { fs.querySelectorAll('input').forEach(function (r) { r.addEventListener('change', pintarPack); }); });

    function seleccion() {
      var vals = [];
      box.querySelectorAll('[data-dc-opcion]').forEach(function (fs) {
        var c = fs.querySelector('input:checked');
        vals[parseInt(fs.getAttribute('data-dc-opcion'), 10)] = c ? c.value : null;
      });
      return vals;
    }

    function actualizar(emitir) {
      var vals = seleccion();
      var v = variantes.find(function (x) { return x.options.every(function (o, i) { return vals[i] == null || vals[i] === o; }); });
      box.querySelectorAll('[data-dc-opcion]').forEach(function (fs) {
        var etiqueta = fs.querySelector('[data-dc-valor-elegido]');
        var c = fs.querySelector('input:checked');
        if (etiqueta && c) etiqueta.textContent = c.value;
      });
      if (!v) {
        if (boton) boton.disabled = true;
        if (botonTexto) botonTexto.textContent = textos.agotado;
        return;
      }
      idInput.value = v.id;
      varActual = v;
      if (boton) boton.disabled = !v.available;
      if (botonTexto) botonTexto.textContent = v.available ? textos.comprar : textos.agotado;
      document.querySelectorAll('[data-dc-precio="' + box.id + '"]').forEach(function (el) { el.textContent = precioTexto(v, "p"); });
      var antes = box.querySelector('[data-dc-antes]'), ahorro = box.querySelector('[data-dc-ahorro]');
      var hayOferta = v.compare_at_price && v.compare_at_price > v.price;
      if (antes) { antes.hidden = !hayOferta; if (hayOferta) antes.textContent = precioTexto(v, "c"); }
      if (ahorro) { ahorro.hidden = !hayOferta; if (hayOferta) ahorro.textContent = ahorro.getAttribute('data-plantilla').replace('[%]', Math.round((1 - v.price / v.compare_at_price) * 100) + '%'); }
      pintarPack();
      if (emitir) {
        if (box.hasAttribute('data-dc-url') && window.history.replaceState) {
          var u = new URL(window.location.href); u.searchParams.set('variant', v.id);
          window.history.replaceState({}, '', u.toString());
        }
        if (v.featured_media && seccion) {
          var gal = seccion.querySelector('[data-dc-galeria]');
          if (gal && gal.__irMedia) gal.__irMedia(v.featured_media.id);
          var img = seccion.querySelector('[data-dc-img-variante]');
          if (img && v.featured_media.preview_image) {
            var src = v.featured_media.preview_image.src;
            img.style.opacity = 0;
            setTimeout(function () { img.src = src + (src.indexOf('?') > -1 ? '&' : '?') + 'width=1200'; img.removeAttribute('srcset'); img.style.opacity = 1; }, 150);
          }
        }
      }
    }

    box.querySelectorAll('[data-dc-opcion] input').forEach(function (inp) { inp.addEventListener('change', function () { actualizar(true); }); });

    box.querySelectorAll('[data-dc-qty]').forEach(function (b) {
      b.addEventListener('click', function () {
        var n = (parseInt(qty.value, 10) || 1) + parseInt(b.getAttribute('data-dc-qty'), 10);
        qty.value = Math.max(1, Math.min(99, n));
      });
    });

    form.addEventListener('submit', function (e) {
      var drawer = document.querySelector('cart-drawer');
      if (!window.fetch) return;
      e.preventDefault();
      if (error) error.textContent = '';
      if (boton) { boton.disabled = true; if (botonTexto) botonTexto.textContent = textos.anadiendo; }
      var items;
      if (esPack()) {
        var cuenta = {};
        variantesPack(packSel().n).forEach(function (x) { cuenta[x.id] = (cuenta[x.id] || 0) + 1; });
        items = Object.keys(cuenta).map(function (id) { return { id: parseInt(id, 10), quantity: cuenta[id] }; });
      } else {
        items = [{ id: parseInt(idInput.value, 10), quantity: (qty && !packRadios.length) ? parseInt(qty.value, 10) || 1 : 1 }];
      }
      var body = { items: items };
      if (drawer) { body.sections = 'cart-drawer,cart-icon-bubble'; body.sections_url = window.location.pathname; }
      var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
      fetch(root + 'cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify(body) })
        .then(function (r) { return r.json().then(function (j) { return { ok: r.ok, j: j }; }); })
        .then(function (res) {
          if (!res.ok) { if (error) error.textContent = res.j.description || res.j.message || 'No se pudo añadir.'; return; }
          if (drawer && res.j.sections && typeof drawer.renderContents === 'function') {
            drawer.classList.remove('is-empty');
            drawer.renderContents({ id: res.j.items ? res.j.items[0].id : idInput.value, sections: res.j.sections });
          } else {
            window.location.href = root + 'cart';
          }
        })
        .catch(function () { form.submit(); })
        .finally(function () { actualizar(false); });
    });

    actualizar(false);
    box.__submit = function () { if (form.requestSubmit) form.requestSubmit(); else form.dispatchEvent(new Event('submit', { cancelable: true })); };
  }

  /* ---------- Barra de compra fija (móvil) ---------- */
  function initBarra() {
    var barra = document.querySelector('[data-dc-barra]');
    if (!barra || barra.__dc) return; barra.__dc = true;
    var box = document.getElementById(barra.getAttribute('data-dc-barra'));
    if (!box) return;
    var ancla = box.querySelector('[data-dc-boton]');
    barra.querySelector('button').addEventListener('click', function () { if (box.__submit) box.__submit(); });
    if (!ancla) return;
    var pendiente = false;
    function comprobar() {
      pendiente = false;
      var r = ancla.getBoundingClientRect();
      barra.classList.toggle('dc-barra--visible', r.bottom < 0);
    }
    window.addEventListener('scroll', function () { if (!pendiente) { pendiente = true; requestAnimationFrame(comprobar); } }, { passive: true });
    comprobar();
  }

  /* ---------- Antes / Después ---------- */
  function initAntesDespues(ad) {
    if (ad.__dc) return; ad.__dc = true;
    var rango = ad.querySelector('[data-dc-ad-rango]');
    var pista = ad.querySelector('[data-dc-ad-pista]');
    if (!rango) return;
    var tocado = false;
    var etqA = ad.querySelector('.dc-ad__etiqueta--antes'), etqD = ad.querySelector('.dc-ad__etiqueta--despues');
    function poner(v) {
      v = parseFloat(v);
      ad.style.setProperty('--dc-pos', v + '%');
      if (etqA) etqA.style.opacity = v < 22 ? 0 : 1;
      if (etqD) etqD.style.opacity = v > 78 ? 0 : 1;
    }
    function marcar() {
      if (tocado) return; tocado = true;
      ad.classList.remove('dc-ad--suave');
      if (pista) pista.classList.add('dc-oculta');
    }
    rango.addEventListener('input', function () { marcar(); poner(rango.value); });
    rango.addEventListener('pointerdown', function () { marcar(); ad.classList.add('dc-ad--activo'); });
    window.addEventListener('pointerup', function () { ad.classList.remove('dc-ad--activo'); });
    poner(rango.value);
    if (!ad.hasAttribute('data-dc-ad-animar') || reduceMotion || !('IntersectionObserver' in window)) return;
    var inicio = parseFloat(rango.value) || 50;
    var io = new IntersectionObserver(function (entries) {
      if (!entries[0].isIntersecting) return;
      io.disconnect();
      var pasos = [inicio - 18, inicio + 18, inicio];
      ad.classList.add('dc-ad--suave');
      pasos.forEach(function (p, i) {
        setTimeout(function () { if (!tocado) { poner(p); rango.value = p; } if (i === pasos.length - 1) setTimeout(function () { ad.classList.remove('dc-ad--suave'); }, 650); }, 500 + i * 700);
      });
    }, { threshold: 0.5 });
    io.observe(ad);
  }

  /* ---------- Entrega estimada (días laborables) ---------- */
  function initEntrega(el) {
    if (el.__dc) return; el.__dc = true;
    var min = parseInt(el.getAttribute('data-min'), 10), max = parseInt(el.getAttribute('data-max'), 10);
    var txt = el.querySelector('[data-dc-entrega-texto]');
    if (!txt || !min || !max) return;
    function sumar(n) {
      var d = new Date();
      d.setDate(d.getDate() + n);
      return d;
    }
    try {
      var f = new Intl.DateTimeFormat('es-ES', { day: 'numeric', month: 'short' });
      txt.textContent = el.getAttribute('data-plantilla').replace('[desde]', f.format(sumar(min)).replace('.', '')).replace('[hasta]', f.format(sumar(max)).replace('.', ''));
    } catch (e) {}
  }

  function initEnvio(el) {
    if (el.__dc) return; el.__dc = true;
    try {
      var f = new Intl.DateTimeFormat('es-ES', { day: 'numeric', month: 'short' });
      var fmt = function (n) { var d = new Date(); d.setDate(d.getDate() + n); return f.format(d).replace('.', ''); };
      el.querySelectorAll('[data-dc-envio-fecha]').forEach(function (s) {
        var a = parseInt(s.getAttribute('data-desde'), 10) || 0, b = parseInt(s.getAttribute('data-hasta'), 10) || 0;
        s.textContent = a === 0 && b === 0 ? 'Hoy, ' + fmt(0) : (b > a ? fmt(a) + ' – ' + fmt(b) : fmt(a));
      });
    } catch (e) {}
    if (reduceMotion || !('IntersectionObserver' in window)) { el.classList.add('dc-envio--activo'); return; }
    var io = new IntersectionObserver(function (en) {
      en.forEach(function (x) { if (x.isIntersecting) { el.classList.add('dc-envio--activo'); io.disconnect(); } });
    }, { threshold: 0.35 });
    io.observe(el);
  }

  function initVideos(pista) {
    if (pista.__dc) return; pista.__dc = true;
    var sec = pista.closest('.dc-videos');
    var vids = pista.querySelectorAll('video');
    function paso() { var c = pista.querySelector('.dc-videos__card'); return c ? c.getBoundingClientRect().width + 16 : 280; }
    var prev = sec.querySelector('[data-dc-vid-prev]'), next = sec.querySelector('[data-dc-vid-next]');
    if (prev) prev.addEventListener('click', function () { pista.scrollBy({ left: -paso(), behavior: 'smooth' }); });
    if (next) next.addEventListener('click', function () { pista.scrollBy({ left: paso(), behavior: 'smooth' }); });
    vids.forEach(function (v) { v.muted = true; v.setAttribute('muted', ''); v.removeAttribute('controls'); });
    pista.querySelectorAll('[data-dc-vid-toggle]').forEach(function (b) {
      b.addEventListener('click', function () {
        var v = b.closest('.dc-videos__media').querySelector('video'); if (!v) return;
        if (v.paused) { v.play().catch(function () {}); } else { v.pause(); }
      });
    });
    vids.forEach(function (v) {
      var card = v.closest('.dc-videos__card');
      v.addEventListener('play', function () { card.classList.add('dc-videos__card--play'); });
      v.addEventListener('pause', function () { card.classList.remove('dc-videos__card--play'); });
    });
    if (reduceMotion || !('IntersectionObserver' in window)) return;
    var io = new IntersectionObserver(function (en) {
      en.forEach(function (e) {
        var v = e.target;
        if (e.isIntersecting && e.intersectionRatio > 0.6) { v.preload = 'auto'; v.play().catch(function () {}); }
        else if (!v.paused) v.pause();
      });
    }, { threshold: [0, 0.6, 1] });
    vids.forEach(function (v) { io.observe(v); });
  }

  function init(root) {
    initReveal(root);
    initBurbujas(root);
    (root || document).querySelectorAll('[data-dc-galeria]').forEach(initGaleria);
    (root || document).querySelectorAll('[data-dc-compra]').forEach(initCompra);
    (root || document).querySelectorAll('[data-dc-ad]').forEach(initAntesDespues);
    (root || document).querySelectorAll('[data-dc-entrega]').forEach(initEntrega);
    (root || document).querySelectorAll('[data-dc-envio]').forEach(initEnvio);
    (root || document).querySelectorAll('[data-dc-videos]').forEach(initVideos);
    initBarra();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(); initParallax(); });
  else { init(); initParallax(); }

  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();
